import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { SmsReportService } from "../../../../../../../../../services/sms-report/sms-report.service";
import { RecordAction } from "../../../../../../../../../utils/enums/shared/enums";
import { WtfAnimations } from "../../../../../../../../../utils/others/core/animations";

@Component({
    selector: "wtf-sms-error-report",
    templateUrl: "./sms-error-report.component.html",
    animations: WtfAnimations,
    providers: [SmsReportService],
})
export class SmsErrorReportComponent implements OnInit {
    id: any;
    campaignData: any;
    chartData: any;

    dialogTitle: string;
    action: RecordAction;

    loading = true;

    errorsData: any;

    constructor(
        public dialogRef: MatDialogRef<SmsErrorReportComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private service: SmsReportService,
        private translateService: TranslateService
    ) {
        this.translateService.setDefaultLang("en");
        this.translateService.use(localStorage.getItem("language") || "en");

        const { id, name } = data;
        this.id = id;
        this.dialogTitle = `Envíos Fallidos`;
        this.dialogTitle = this.translateService.instant(this.dialogTitle);
        this.dialogTitle = `${name} - ${this.dialogTitle}`;
        this.campaignData = data;
    }

    ngOnInit(): void {
        this.getData();
    }

    getData() {
        if (this.data.isForCompany) {
            this.service
                .getErrorDetailForCompany(this.data.filters)
                .subscribe((result: any[]) => {
                    this.errorsData = result
                        .filter((item) => item.codeError !== "Success (code 0)")
                        .map((item) => {
                            return {
                                ...item,
                                codeError: item.codeError.toString(),
                            };
                        });
                    this.loading = false;
                });
        } else {
            this.service.getErrorDetails(this.id).subscribe((result: any[]) => {
                this.errorsData = result
                    .filter((item) => item.codeError !== "Success (code 0)")
                    .map((item) => {
                        if (item.codeError === null) {
                            return {
                                ...item,
                                codeError: "501",
                            };
                        } else {
                            return {
                                ...item,
                                codeError: item.codeError.toString(),
                            };
                        }
                    });
                this.loading = false;
            });
        }
    }
}
